/* Real home videos (customer and creator clips): product gallery tile, homepage "In real homes" strip,
   collection grid card. Every <video> ships preload="none" with a poster, so nothing downloads on load.
   data-ugc-mode="view"  plays muted while at least half of it is on screen
   data-ugc-mode="hover" plays muted on mouse hover (desktop); on touch screens it behaves like "view"
   Phones: in-view play is armed only after the shopper first scrolls or touches the page, so a clip that
   happens to sit above the fold never downloads on its own. Reduced motion or Save-Data: no autoplay at all.
   [data-ugc-open] opens the clip full screen with sound (Esc, the close button or a tap outside closes it). */
(function () {
  if (window.RBUGC) { window.RBUGC.scan(); return; }
  const fine = matchMedia('(hover: hover) and (pointer: fine)').matches;
  const calm = matchMedia('(prefers-reduced-motion: reduce)').matches || (navigator.connection && navigator.connection.saveData);
  let armed = fine;
  const seen = new WeakSet();
  const visible = new Set();

  const play = (v) => { if (calm || !v) return; const p = v.play(); if (p && p.catch) p.catch(() => {}); };
  const stop = (v) => { if (v && !v.paused) v.pause(); };
  const vidOf = (box) => box.querySelector('video');

  const io = 'IntersectionObserver' in window ? new IntersectionObserver((entries) => {
    entries.forEach((e) => {
      const box = e.target;
      if (e.isIntersecting && e.intersectionRatio >= 0.5) { visible.add(box); if (armed) play(vidOf(box)); }
      else { visible.delete(box); stop(vidOf(box)); }
    });
  }, { threshold: [0, 0.5] }) : null;

  function arm() {
    if (armed) return; armed = true;
    visible.forEach((box) => play(vidOf(box)));
  }
  if (!armed) ['scroll', 'touchstart', 'pointerdown', 'keydown'].forEach((ev) => addEventListener(ev, arm, { once: true, passive: true }));

  function scan() {
    document.querySelectorAll('[data-ugc]').forEach((box) => {
      if (seen.has(box)) return; seen.add(box);
      const v = vidOf(box); if (!v) return;
      v.muted = true; v.setAttribute('muted', ''); v.playsInline = true;
      const hover = box.dataset.ugcMode === 'hover' && fine;
      if (hover) {
        box.addEventListener('mouseenter', () => play(v));
        box.addEventListener('mouseleave', () => stop(v));
      } else if (io) io.observe(box);
    });
  }

  // ---------- full screen with sound ----------
  let modal = null, mv = null, back = null;
  function close() {
    if (!modal || modal.hidden) return;
    if (mv) { mv.pause(); mv.remove(); mv = null; }
    modal.hidden = true; document.documentElement.classList.remove('ugc-lock');
    if (back) { back.focus({ preventScroll: true }); back = null; }
  }
  function build(box) {
    modal = document.createElement('div');
    modal.className = 'ugc-modal'; modal.hidden = true;
    modal.setAttribute('role', 'dialog'); modal.setAttribute('aria-modal', 'true');
    const lbl = (box.dataset.ugcClose || 'Close video').replace(/"/g, '');
    modal.innerHTML = `<div class="ugc-modal-stage"></div><div class="ugc-modal-cap"></div><button type="button" class="ugc-modal-x" aria-label="${lbl}"><svg viewBox="0 0 24 24" width="22" height="22" fill="none" stroke="currentColor" stroke-width="1.5" aria-hidden="true"><path d="M5 5l14 14M19 5L5 19"/></svg></button>`;
    modal.addEventListener('click', (e) => { if (e.target === modal || e.target.closest('.ugc-modal-x')) close(); });
    addEventListener('keydown', (e) => { if (e.key === 'Escape') close(); });
    document.body.appendChild(modal);
  }
  function open(box, trigger) {
    const src = vidOf(box); if (!src) return;
    if (!modal) build(box);
    stop(src);
    back = trigger || null;
    mv = src.cloneNode(true);
    mv.removeAttribute('tabindex'); mv.className = 'ugc-modal-v';
    mv.muted = false; mv.removeAttribute('muted'); mv.controls = true; mv.loop = false; mv.preload = 'auto'; mv.playsInline = true;
    const stage = modal.querySelector('.ugc-modal-stage'); stage.innerHTML = ''; stage.appendChild(mv);
    const cap = modal.querySelector('.ugc-modal-cap'); const c = box.closest('[data-ugc-card]');
    const capSrc = c && c.querySelector('[data-ugc-cap]');
    cap.innerHTML = capSrc ? capSrc.innerHTML : ''; cap.hidden = !capSrc;
    modal.setAttribute('aria-label', (trigger && trigger.getAttribute('aria-label')) || '');
    modal.hidden = false; document.documentElement.classList.add('ugc-lock');
    modal.querySelector('.ugc-modal-x').focus({ preventScroll: true });
    const p = mv.play(); if (p && p.catch) p.catch(() => {});
  }
  document.addEventListener('click', (e) => {
    const t = e.target.closest('[data-ugc-open]'); if (!t) return;
    const wall = t.closest('[data-wall]'); if (wall && wall.classList.contains('dragging')) return;
    const box = t.closest('[data-ugc]'); if (!box) return;
    e.preventDefault(); e.stopPropagation();
    open(box, t);
  }, true);

  window.RBUGC = { scan, open, close };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', scan); else scan();
})();
